import { createAction } from 'typesafe-actions';

export const showFullPageLoadingIndicator = createAction('fullPageLoadingIndicator/SHOW_FULL_PAGE_LOADING_INDICATOR')<void>();

export const hideFullPageLoadingIndicator = createAction('fullPageLoadingIndicator/HIDE_FULL_PAGE_LOADING_INDICATOR')<void>();
